import { apiClient, ApiResult } from "@/lib/api-client"

export interface LoginResponse {
  user: {
    id?: string
    externalId?: string
    status: number
    email: string
    firstName: string
    lastName: string
    createdAt?: string
    lastLoginAt?: string
    currentOrganizationId?: string | null
    needsLegalConsent?: boolean
    organizationRole?: string | null
  }
  roles: string[]
  permissions: string[]
  expiresAt: string
}

export const LoginAsync = async (credentials: {
  email: string
  password: string
  inviteToken?: string
  captchaToken?: string
}): Promise<LoginResponse> => {
  const res = await apiClient.post<ApiResult<LoginResponse>>(
    `/auth/login`,
    { ...credentials, captchaToken: credentials.captchaToken ?? "" },
  )

  if (!res.data.isSuccess || !res.data.value) {
    throw {
      error: res.data.error ?? "Login failed",
      errorCode: res.data.errorCode,
    }
  }

  return res.data.value
}
